(function () {
  'use strict';

  const ICONS = {
    close: `
      <svg class="icon icon-close icon-sm" viewBox="0 0 20 20" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M5 15L15 5M5 5L15 15"></path>
      </svg>
    `,
    chevron: `
      <svg class="icon icon-chevron-up icon-sm absolute pointer-events-none custom-rebuy-shipping-estimator__field-icon" viewBox="0 0 24 24" stroke="currentColor" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 15L12 9L18 15"></path>
      </svg>
    `,
  };

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function renderButtonInner(label) {
    return `
      <span class="btn-fill" data-fill></span>
      <span class="btn-text">${escapeHtml(label)}</span>
    `;
  }

  function renderIconButtonInner(iconMarkup) {
    return `
      <span class="btn-fill" data-fill></span>
      <span class="btn-text">${iconMarkup}</span>
      <span class="btn-loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `;
  }

  function render3dButtonInner(label) {
    return `
      <span class="btn-fill" data-fill></span>
      <div class="product-card__btn-text add_to_cart_text_custom">${escapeHtml(label)}</div>
      <span class="btn-loader">
        <span></span>
        <span></span>
        <span></span>
      </span>
    `;
  }

  function renderSelectField({ fieldClass = '', id, name, label, hidden = false, dataAttribute = '' }) {
    const fieldClasses = ['field', fieldClass].filter(Boolean).join(' ');

    return `
      <div class="${escapeHtml(fieldClasses)}"${dataAttribute ? ` ${dataAttribute}` : ''}${hidden ? ' hidden' : ''}>
        <select
          id="${escapeHtml(id)}"
          name="${escapeHtml(name)}"
          class="select is-floating"
          is="custom-select"
          autocomplete="${name === 'country' ? 'country' : 'address-level1'}"
        ></select>
        ${ICONS.chevron}
        <label class="label is-floating" for="${escapeHtml(id)}">${escapeHtml(label)}</label>
      </div>
    `;
  }

  function renderMarkup({ ids, strings }) {
    const titleId = `${ids.modal}-title`;

    return `
      <div class="custom-rebuy-shipping-estimator__summary">
          <span class="custom-rebuy-shipping-estimator__summary-label">${escapeHtml(strings.summaryLabel)}</span>
          <button
            type="button"
            class="button button--secondary button--small custom-rebuy-shipping-estimator__summary-button"
            aria-controls="${escapeHtml(ids.modal)}"
            aria-expanded="false"
          >
            ${renderButtonInner(strings.summaryAction)}
          </button>
      </div>
      <modal-element
        id="${escapeHtml(ids.modal)}"
        class="modal custom-rebuy-shipping-estimator__modal invisible absolute top-0 left-0 bottom-0 w-full h-full"
        role="dialog"
        aria-modal="true"
        aria-labelledby="${escapeHtml(titleId)}"
        hidden
        data-custom-rebuy-shipping-estimator-modal
      >
        <overlay-element
          class="overlay fixed-modal invisible opacity-0 absolute top-0 left-0 w-full h-full pointer-events-none"
          aria-controls="${escapeHtml(ids.modal)}"
          aria-expanded="false"
        ></overlay-element>
        <div class="modal__container custom-rebuy-shipping-estimator__sheet flex flex-col z-3 absolute left-0 bottom-0 w-full">
          <div class="modal__header custom-rebuy-shipping-estimator__sheet-header flex items-center justify-between relative">
            <span id="${escapeHtml(titleId)}" class="font-medium text-sm md:text-base">${escapeHtml(strings.title)}</span>
            <button
              type="button"
              class="button button--secondary button--close drawer__close flex items-center justify-center custom-rebuy-shipping-estimator__close"
              is="hover-button"
              data-estimator-close
              aria-controls="${escapeHtml(ids.modal)}"
              aria-expanded="false"
              aria-label="${escapeHtml(strings.close)}"
            >
              ${renderIconButtonInner(ICONS.close)}
            </button>
          </div>

          <div class="modal__content custom-rebuy-shipping-estimator__content flex flex-col overflow-hidden">
            <form class="modal__scrollable custom-rebuy-shipping-estimator__form grid gap-4" data-estimator-form novalidate>
              ${renderSelectField({
                id: ids.country,
                name: 'country',
                label: strings.countryLabel,
              })}
              ${renderSelectField({
                fieldClass: 'custom-rebuy-shipping-estimator__province-field',
                id: ids.province,
                name: 'province',
                label: strings.provinceLabel,
                hidden: true,
                dataAttribute: 'data-estimator-province-field',
              })}
              <div class="field">
                <input
                  id="${escapeHtml(ids.zip)}"
                  name="zip"
                  class="input is-floating"
                  type="text"
                  autocomplete="postal-code"
                  autocapitalize="characters"
                  placeholder=" "
                >
                <label class="label is-floating" for="${escapeHtml(ids.zip)}">${escapeHtml(strings.zipLabel)}</label>
              </div>
              <div class="justify-self-start custom-rebuy-shipping-estimator__submit-wrap">
                <button
                  class="btn-3d btn-3d-custom btn-3d-custom-outside button button--primary flex justify-center items-center flex-wrap gap-x-4 gap-y-2 custom-rebuy-shipping-estimator__submit"
                  type="submit"
                  is="hover-button"
                  data-estimator-submit
                >
                  ${render3dButtonInner(strings.calculate)}
                </button>
              </div>
              <div class="custom-rebuy-shipping-estimator__results alert alert--info" data-estimator-results hidden></div>
            </form>
          </div>
        </div>
      </modal-element>
    `;
  }

  window.CustomRebuyShippingEstimatorUI = {
    renderMarkup,
  };
})();
